import { tv } from 'tailwind-variants';

export const carouselWrapperVariants = tv({
  slots: {
    base: ['relative w-full'],
    viewport: ['overflow-hidden'],
    container: ['flex'],
    slide: ['min-w-0 shrink-0 grow-0'],

    // Fade-specific: slides stack on top of each other
    fadeContainer: ['flex'],
    fadeSlide: ['w-full min-w-0 shrink-0 grow-0'],

    // Arrow navigation (side-positioned variant — enabled via arrowLayout='sides')
    arrowButton: [
      'absolute top-1/2 -translate-y-1/2 z-9',
      'flex items-center justify-center',
      'w-10 h-10 rounded-full',
      'text-dark-blue',
      'transition-colors cursor-pointer',
      'disabled:opacity-30 disabled:cursor-not-allowed',
    ],
    arrowPrev: ['left-2 md:left-4'],
    arrowNext: ['right-2 md:right-4'],

    // Dot indicators — max-w-full keeps fit-content from resolving to max-content so the row always wraps
    controlsWrapper: [
      'w-fit max-w-full',
      'mx-auto',
      'flex flex-wrap items-center justify-center gap-3 mt-9.5 mb-4',
    ],
    dotButton: [
      'w-4.5! h-4.5!',
      'rounded-full',
      'bg-medium-gray',
      'transition-all duration-300',
      'flex items-center justify-center',
      'cursor-pointer p-0 border-none',
      'opacity-50',
    ],
    dotActive: ['bg-dark-blue', 'opacity-100'],
    // Own centered line below the dots on small screens; inline after the last dot from lm up
    autoplayButtonWrapper: ['basis-full lm:basis-auto', 'flex justify-center', 'mt-2 lm:mt-0'],
    autoplayButton: ['flex items-center justify-center', 'text-xl text-primary', 'cursor-pointer'],
    paginationArrow: [
      'flex items-center justify-center',
      '[&_svg]:w-[18px] [&_svg]:h-[18px] xm:[&_svg]:w-6 xm:[&_svg]:h-6',
      'text-dark-blue',
      'cursor-pointer border-none transition-colors',
      'disabled:opacity-30 disabled:cursor-not-allowed',
    ],

    // Thumbnail strip
    thumbsViewport: ['overflow-hidden', 'w-full', 'mx-auto'],
    thumbsContainer: ['flex items-stretch justify-start gap-8'],
    thumbButton: [
      'relative',
      'appearance-none',
      'rounded',
      'cursor-pointer',
      "before:content-[''] before:w-full before:h-full",
      'before:absolute before:top-0 before:left-0 before:rounded',
      'before:border-[2px] before:border-slider-thumb-button-border',
      'before:pointer-events-none before:z-10',
      'overflow-hidden',
    ],
    thumbButtonSelected: [
      'opacity-100',
      'before:border-[5px]',
      'before:w-[calc(100%_+_0px)] before:h-[calc(100%_+_0px)]',
      'before:border-bright-blue',
    ],
  },
  variants: {
    hasThumbnails: {
      true: {
        viewport: ['mb-5.5'],
      },
    },
    isContainerBleedCarousel: {
      true: {
        thumbsViewport: ['px-3 md:px-0'],
      },
    },
    // Required by embla-carousel-auto-height: slides must NOT stretch, otherwise every slide
    // measures the same height and the plugin has nothing to shrink to. The transition animates
    // the inline height the plugin writes onto the container.
    autoHeight: {
      true: {
        container: [
          'items-start',
          'transition-[height] duration-300 ease-out motion-reduce:transition-none',
        ],
        fadeContainer: [
          'items-start',
          'transition-[height] duration-300 ease-out motion-reduce:transition-none',
        ],
      },
    },
  },
});
